/* ABCD fixes — quick add currency, quick add UX, unique size labels.
   Loaded after custom.js (see snippets/olyx-fixes.liquid). */
(function () {
  'use strict';
  if (window.__olyxFixesLoaded) return;
  window.__olyxFixesLoaded = true;

  var CFG = window.OlyxFixesConfig || {};

  /* ------------------------------------------------------------------
   * 1. Money formatting in the customer's (presentment) currency.
   *    Liquid renders a sample amount with the active currency's own
   *    format (e.g. "$123,456.78" or "€123.456,78"); we copy that pattern
   *    so JS prices always match the prices printed by Liquid.
   * ------------------------------------------------------------------ */
  function buildPattern(sample) {
    sample = String(sample || '').replace(/<[^>]*>/g, '').trim();
    var i1 = sample.indexOf('123');
    var i2 = sample.indexOf('456', i1 + 3);
    if (i1 < 0 || i2 < 0) return null;
    var i3 = sample.indexOf('78', i2 + 3);
    var hasDecimals = i3 >= 0;
    var end = hasDecimals ? i3 + 2 : i2 + 3;
    return {
      prefix: sample.slice(0, i1),
      thousands: sample.slice(i1 + 3, i2),
      decimal: hasDecimals ? sample.slice(i2 + 3, i3) : '',
      decimals: hasDecimals ? 2 : 0,
      suffix: sample.slice(end)
    };
  }

  var pattern = buildPattern(CFG.moneySample);

  function groupThousands(intStr, sep) {
    return intStr.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  }

  function formatCents(cents, keepZeros) {
    var value = (parseInt(cents, 10) || 0) / 100;
    var p = pattern;
    if (!p) {
      var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || CFG.currency || 'USD';
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency', currency: cur, currencyDisplay: 'narrowSymbol'
        }).format(value);
      } catch (e) {
        return value.toFixed(2);
      }
    }
    var fixed = value.toFixed(p.decimals);
    var parts = fixed.split('.');
    var out = groupThousands(parts[0], p.thousands);
    if (p.decimals && parts[1] && (keepZeros || parts[1] !== '00')) {
      out += p.decimal + parts[1];
    }
    return p.prefix + out + p.suffix;
  }

  // custom.js (quick add, swatches, cart) calls window.olyxFormatMoney at run time.
  window.olyxFormatMoney = function (cents) { return formatCents(cents, false); };
  window.OlyxMoney = { format: formatCents };

  /* ------------------------------------------------------------------
   * 1b. Size labels in the visitor's own size system.
   *     layout/theme.liquid converts the page as a whole, but anything
   *     rendered late (quick add, lazy-loaded cards, the cart drawer) could
   *     miss that pass and keep the raw
   *     "EU 42 / US M 8.5 / US W 10 / UK 7.5" value. We redo the same
   *     conversion on the size controls we own, so it can't be missed.
   * ------------------------------------------------------------------ */
  var SYSTEM = (function () {
    var c = ' ' + document.documentElement.className + ' ';
    if (c.indexOf(' olyx-sizes-us ') > -1) return 'US';
    if (c.indexOf(' olyx-sizes-uk ') > -1) return 'UK';
    if (c.indexOf(' olyx-sizes-eu ') > -1) return 'EU';
    var iso = '';
    try { iso = (window.Shopify && window.Shopify.country) || CFG.country || ''; } catch (e) {}
    iso = String(iso).toUpperCase();
    if (iso === 'US') return 'US';
    if (iso === 'GB' || iso === 'UK') return 'UK';
    return 'EU';
  })();

  // "EU 42", "US M 8.5", "UK 7.5" — every part has to look like this before we
  // touch the text, so ordinary copy ("US shipping / UK shipping", "Home / Sale")
  // is never rewritten.
  var SIZE_PART = /^(EU|US|UK)\s+(M\s+|W\s+)?[\d]+(\.[\d]+)?$/i;

  function localise(text) {
    text = String(text == null ? '' : text).trim();
    if (text.indexOf('/') === -1 || !/\b(EU|US|UK)\s/.test(text)) return text;
    var parts = text.split('/').map(function (p) { return p.trim(); }).filter(Boolean);
    if (parts.length < 2) return text;
    for (var i = 0; i < parts.length; i++) {
      if (!SIZE_PART.test(parts[i])) return text;
    }
    var keep = parts.filter(function (p) {
      if (SYSTEM === 'US') return /^US\b/i.test(p);
      if (SYSTEM === 'UK') return /^UK\b/i.test(p);
      return /^EU\b/i.test(p);
    }).map(function (p) {
      return p.replace(/^(EU|US|UK)\s+/i, '');
    });
    return keep.length ? keep.join(' / ') : text;
  }

  // Same conversion the theme does, re-applied over the live DOM. Our observer
  // below is debounced but never drops a batch, so quick add, lazy-loaded
  // product cards and the cart drawer are covered however late they render.
  function localiseAll() {
    var body = document.body;
    if (!body) return;

    body.querySelectorAll('option').forEach(function (o) {
      var t = o.textContent.trim();
      var v = localise(t);
      if (v !== t) o.textContent = v; // the <option value> is never touched
    });

    var tw = document.createTreeWalker(body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        var p = n.parentNode;
        if (!p) return NodeFilter.FILTER_REJECT;
        var tag = p.nodeName;
        if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'OPTION' ||
            tag === 'TEXTAREA' || tag === 'INPUT') return NodeFilter.FILTER_REJECT;
        return (n.nodeValue.indexOf('/') !== -1 && /\b(EU|US|UK)\s/.test(n.nodeValue))
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_REJECT;
      }
    });
    var nodes = [], n;
    while ((n = tw.nextNode())) nodes.push(n);
    nodes.forEach(function (node) {
      var t = node.nodeValue.trim();
      var v = localise(t);
      if (v !== t) node.nodeValue = v;
    });
  }

  /* ------------------------------------------------------------------
   * 2. Unique size labels.
   *    Some imported size charts give two EU sizes the same US size
   *    (e.g. EU 39.5 and EU 40 both "US M 7"), so the size appeared twice.
   *    The smaller EU size is half a US size smaller on the standard
   *    Nike / New Balance / Timberland / ASICS / UGG charts, so we show
   *    that. If that label is already taken we add the EU size instead.
   * ------------------------------------------------------------------ */
  function parseSize(raw) {
    var m = String(raw || '').match(/EU\s*([\d.]+)[^/]*\/\s*US\s*M\s*([\d.]+)\s*\/\s*US\s*W\s*([\d.]+)/i);
    if (!m) return null;
    return { eu: parseFloat(m[1]), m: parseFloat(m[2]), w: parseFloat(m[3]) };
  }

  function num(n) { return String(Math.round(n * 10) / 10); }

  /* items: [{ raw: 'EU 40 / US M 7 / ...', text: 'M 7 / W 8.5', set: fn(label) }] */
  function makeUnique(items) {
    var byText = {};
    var used = {};
    items.forEach(function (it) {
      var t = (it.text || '').trim();
      it.text = t;
      used[t] = true;
      (byText[t] = byText[t] || []).push(it);
    });

    Object.keys(byText).forEach(function (t) {
      var group = byText[t];
      if (group.length < 2) return;
      group.forEach(function (it) { it.p = parseSize(it.raw); });
      group.sort(function (a, b) {
        return ((b.p && b.p.eu) || 0) - ((a.p && a.p.eu) || 0);
      });
      // largest EU keeps the label, the smaller ones step down half a size
      var needSub = false;
      for (var i = 1; i < group.length; i++) {
        var it = group[i];
        var label = null;
        if (it.p && /^M\s/.test(t)) {
          var cand = 'M ' + num(it.p.m - 0.5 * i) + ' / W ' + num(it.p.w - 0.5 * i);
          if (!used[cand]) label = cand;
        }
        if (label) {
          used[label] = true;
          it.done = true;
          it.set(label);
        } else {
          needSub = true;
        }
      }
      // Could not step down without clashing: keep the US size and add the EU size underneath
      if (needSub) {
        group.forEach(function (it, idx) {
          if (it.done) return;
          it.set(t, it.p ? 'EU ' + num(it.p.eu) : '#' + (idx + 1));
        });
      }
    });
  }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function setText(el, label, sub) {
    if (!el) return;
    var html = esc(label) + (sub ? '<span class="OlyxSizeSub">' + esc(sub) + '</span>' : '');
    if (el.getAttribute('data-olyx-html') !== html || !el.getAttribute('data-olyx-label') ||
        el.textContent.trim() !== el.getAttribute('data-olyx-label')) {
      el.innerHTML = html;
      el.setAttribute('data-olyx-html', html);
      el.setAttribute('data-olyx-label', el.textContent.trim());
    }
  }

  // Product page size buttons
  function fixPdpSizes() {
    document.querySelectorAll('.OlyxInline__SizeList').forEach(function (list) {
      var btns = list.querySelectorAll('.OlyxSizeBtn');
      if (btns.length < 2) return;
      var items = [];
      btns.forEach(function (b) {
        var fixed = b.getAttribute('data-olyx-label');
        // custom.js may re-render: if our label got overwritten, recompute from its text
        var text = fixed && b.textContent.trim() === fixed ? b.getAttribute('data-olyx-orig') || fixed : localise(b.textContent.trim());
        if (!b.getAttribute('data-olyx-orig') || b.textContent.trim() !== fixed) b.setAttribute('data-olyx-orig', text);
        items.push({
          raw: b.getAttribute('data-olyx-val'),
          text: b.getAttribute('data-olyx-orig'),
          set: function (label, sub) { setText(b, label, sub); }
        });
      });
      makeUnique(items);
    });
  }

  /* ------------------------------------------------------------------
   * 3. Quick add drawer upgrades
   * ------------------------------------------------------------------ */
  var lastCard = null;
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-quick-add-open]');
    if (t) lastCard = t.closest('[data-quick-add-container]');
  }, true);

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }

  var ICON_CHECK = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3.5 8.5l3 3 6-7" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function enhanceDrawer(drawer) {
    var panel = drawer.querySelector('.QuickAddDrawer__Panel');
    if (!panel) return;
    var container = lastCard;
    var productItem = container && container.closest('.ProductItem');

    // Title
    var title = drawer.querySelector('.QuickAddDrawer__Title');
    if (title && CFG.titleText && title.textContent.trim() !== CFG.titleText) title.textContent = CFG.titleText;

    // Compare-at price + saving badge, copied from the card (already in the right currency)
    var priceBox = drawer.querySelector('[data-quick-add-product-price]');
    if (priceBox && productItem) {
      var cmp = productItem.querySelector('.Price--compareAt');
      var existing = priceBox.querySelector('.OlyxQA__Compare');
      var cmpText = cmp ? cmp.textContent.trim() : '';
      if (cmpText) {
        if (!existing) {
          existing = el('span', 'OlyxQA__Compare');
          priceBox.appendChild(existing);
        }
        if (existing.textContent !== cmpText) existing.textContent = cmpText;
        var saveLbl = productItem.querySelector('.ProductItem__Label--sale');
        var badge = priceBox.querySelector('.OlyxQA__Save');
        if (saveLbl) {
          if (!badge) { badge = el('span', 'OlyxQA__Save'); priceBox.appendChild(badge); }
          if (badge.textContent !== saveLbl.textContent.trim()) badge.textContent = saveLbl.textContent.trim();
        }
      } else if (existing) {
        existing.remove();
        var b2 = priceBox.querySelector('.OlyxQA__Save');
        if (b2) b2.remove();
      }
    }

    // Links row: size guide + full details
    var body = drawer.querySelector('.QuickAddDrawer__State');
    var options = drawer.querySelector('[data-quick-add-options-list]');
    if (body && options && !drawer.querySelector('.OlyxQA__Links')) {
      var links = el('div', 'OlyxQA__Links');
      links.innerHTML =
        '<span class="OlyxQA__Hint">' + (CFG.sizeHint || 'Kies je maat') + '</span>' +
        '<a class="OlyxQA__Link" href="' + (CFG.sizeGuideUrl || '/pages/size-guide') + '" target="_blank" rel="noopener">Maattabel</a>';
      options.parentNode.insertBefore(links, options);
    }
    var sizeGuide = drawer.querySelector('.OlyxQA__Links');
    if (sizeGuide) {
      var isShoe = container && /EU\s*\d/.test((container.querySelector('[data-size-label]') || {}).getAttribute ? container.querySelector('[data-size-label]').getAttribute('data-size-label') : '');
      sizeGuide.classList.toggle('is-shoe', !!isShoe);
      var hint = sizeGuide.querySelector('.OlyxQA__Hint');
      var hintText = isShoe ? (CFG.shoeHint || 'EU-maten') : (CFG.sizeHint || 'Kies je maat');
      if (hint && hint.textContent !== hintText) hint.textContent = hintText;
    }

    // Size labels: unique + readable
    if (options && container) {
      var sources = container.querySelectorAll('[data-quick-add-variant]');
      var items = [];
      options.querySelectorAll('.QuickAddDrawer__Option[data-source-index]').forEach(function (opt) {
        var src = sources[parseInt(opt.getAttribute('data-source-index'), 10)];
        var valEl = opt.querySelector('.QuickAddDrawer__OptionValue');
        if (!src || !valEl) return;
        var fixed = valEl.getAttribute('data-olyx-label');
        if (!fixed || valEl.textContent.trim() !== fixed) {
          valEl.setAttribute('data-olyx-orig', localise(valEl.textContent.trim()));
        }
        items.push({
          raw: src.getAttribute('data-size-label') || src.getAttribute('data-variant-title'),
          text: valEl.getAttribute('data-olyx-orig'),
          set: function (label, sub) { setText(valEl, label, sub); }
        });
      });
      makeUnique(items);

      // Hide the per-size price when every size costs the same (less noise)
      var prices = {};
      options.querySelectorAll('.QuickAddDrawer__OptionPrice').forEach(function (p) { prices[p.textContent.trim()] = 1; });
      options.classList.toggle('OlyxQA--samePrice', Object.keys(prices).length <= 1);
      options.classList.toggle('OlyxQA--many', options.children.length > 6);
    }

    // Trust row + full details link under the button
    var footer = drawer.querySelector('.QuickAddDrawer__Footer');
    if (footer && !footer.querySelector('.OlyxQA__Trust')) {
      var trust = el('ul', 'OlyxQA__Trust');
      (CFG.trust || ['Verzending met track & trace', '14 dagen retour', '100% authentiek']).forEach(function (t) {
        var li = el('li', null, ICON_CHECK + '<span>' + t + '</span>');
        trust.appendChild(li);
      });
      var submit = footer.querySelector('[data-quick-add-submit]');
      if (submit && submit.nextSibling) footer.insertBefore(trust, submit.nextSibling);
      else footer.appendChild(trust);
    }
    var details = footer && footer.querySelector('.OlyxQA__Details');
    var link = drawer.querySelector('[data-quick-add-product-link]');
    if (footer && link) {
      if (!details) {
        details = el('a', 'OlyxQA__Details', 'Bekijk alle details <span aria-hidden="true">&rarr;</span>');
        footer.appendChild(details);
      }
      if (details.getAttribute('href') !== link.getAttribute('href')) details.setAttribute('href', link.getAttribute('href'));
    }
  }

  var scheduled = false;
  function run() {
    scheduled = false;
    try { localiseAll(); } catch (e) { /* no-op */ }
    try { fixPdpSizes(); } catch (e) { /* no-op */ }
    var drawer = document.querySelector('div.QuickAddDrawer');
    if (drawer && document.documentElement.classList.contains('QuickAddDrawer-open')) {
      try { enhanceDrawer(drawer); } catch (e) { /* no-op */ }
    }
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(run, 30); // not rAF: it never fires in background tabs
  }

  var mo = new MutationObserver(schedule);
  function start() {
    mo.observe(document.body, { childList: true, subtree: true, characterData: true });
    mo.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    run();
    setTimeout(run, 600);
    setTimeout(run, 2000);
    setTimeout(run, 4000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
